import { Component, OnInit, Input, HostListener, ViewChild } from '@angular/core';
import { FormArray, ReactiveFormsModule, FormsModule, Validators } from '@angular/forms';
import { ApprovalsService, DataService, UserService, OperationsService, LoansService } from '../../_services/index';
import { AuthenticationService, StorageService, AnalyticsService } from '../../_services/index';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { Router } from '@angular/router';  
import { ProductsService } from '../../_services/products.service';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-rsummary',
  templateUrl: './rsummary.component.html',
  styleUrls: ['./rsummary.component.css']
})
export class RsummaryComponent implements OnInit {

  loading = false;
  start_date = '';
  end_date = '';
  customers:any;
  currentUser:any;
  products:any;
  loan_product_id:any;
  constructor(
    public fb: FormBuilder,
    public operationsService: OperationsService,
    public storageService: StorageService,
    private toastr: ToastrService,
    private productService:ProductsService
  ) {
    this.currentUser = this.storageService.read<any>("currentUser");
    this.productService
    .getLoanProductsSlim(this.currentUser.token)
    .subscribe(companies => (this.products = companies));
  }

  ngOnInit() {
    this.getCyberpayPayments();
  }
  getCyberpayPayments() {

    this.loading = true;
    this.operationsService.getRReports(this.currentUser.token,this.start_date, this.end_date, this.loan_product_id)
      .subscribe(employee_performance => {
        this.loading = false;
        this.customers = employee_performance.data
      });

  }
  // isItCCs(customerEmail){
  //   this.loading = true;
  //   this.loansService.isItCCs(customerEmail, this.currentUser.token)
  //     .subscribe(result => {
  //       return result;
  //     });
  // }
}
